<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Smoke and Mirrors</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h2 class="chapter-number">ACKNOWLEDGMENTS</h2>
<p class="flush-left-opener"><span class="big">T</span>he best advice I’ve ever heard regarding research came from none other than the great mystery writer Elizabeth Peters (if you haven’t read her Amelia Peabody books, don’t delay). We were discussing a problem I had with a Victorian-era book I was writing. A fabulous diamond figured into the plot and I wanted it to tie into ancient Egypt, only I found out the Egyptians didn’t mine diamonds.</p>
<p class="indented">Her response was priceless—</p>
<p class="indented">‘That’s when you say, it was a <em>rare</em> example of an Egyptian diamond!’</p>
<p class="indented">I kept that wisdom in mind as I was writing <em>Smoke and Mirrors</em>. Yes, I researched the heck out of New York in 1842, the American Museum, the Barnum family, and a host of other details. But I fudged a little, too, for the sake of the story. I took the biggest liberty with P.T. Barnum’s family. He did have sisters, but not one named Evangeline.</p>
<p class="indented">The details of the museum itself are true and yes, it was an amazing place. Live animals (including a whale!), strange displays, a wax museum … the list of wonders and curiosities goes on. Once I read about the American Museum, I couldn’t resist setting a mystery there.</p>
<p class="indented">As always, I need to thank a host of people for their help and support including Gail Fortune, my agent, and the members of my wonderful brainstorming group: Shelley Costa, Serena Miller and Emilie Richards, all great writers. Their books are well worth reading.</p>
<p class="indented">And of course, a big thank you to my family. My husband, David, is always there for me. Ernie, the Airedale, is ever at my side, even though he’s usually sleeping. Just as I finished this book, we welcomed a new addition, Lucy, the big, mixed breed … er … well, Lucy is every much an oddity as those in the American Museum.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter000.vue?7e89d6ba